import { gql } from "@apollo/client";

import IndividualNoteNodeFragment from "@apps/meeting-new/graphql/individual-note-node-fragment";
import MeetingViewMeetingNewNodeFragment from "@apps/meeting-new/graphql/meeting-view-meeting-node-fragment";
import { TopicDataFragment } from "@graphql/fragments";

export const TopicSidebarTopicNode = gql`
  ${IndividualNoteNodeFragment}
  ${TopicDataFragment}
  fragment TopicSidebarTopicNode on TopicNode {
    ...TopicDataFragment
    discussionNotes
    includesIndividualNotes
    includesIndividualNotesForCurrentUser
    includesSharedNotes
    notesRequirement
    individualNotes {
      edges {
        node {
          ...IndividualNoteNodeFragment
        }
      }
    }
    meeting {
      id
      title
      startDatetime
      websocketToken
      organization {
        id
      }
      meetingGroup {
        id
        isFormalOneonone
      }
      participants {
        edges {
          node {
            id
            status
            user {
              id
              name
              firstName
              lastName
              avatar
            }
          }
        }
      }
    }
  }
`;

export default gql`
  ${TopicSidebarTopicNode}
  ${MeetingViewMeetingNewNodeFragment}
  query getTopicSidebar($topicId: Int!) {
    topic(topicId: $topicId) {
      ...TopicSidebarTopicNode
      discussionNotes
      includesIndividualNotes
      includesIndividualNotesForCurrentUser
      includesSharedNotes
      individualNotes {
        edges {
          node {
            id
            creator {
              id
            }
            notes
            enabled
            hidden
          }
        }
      }
      meeting {
        ...MeetingViewMeetingNodeNewPageFragment
        id
        title
        startDatetime
        websocketToken
        organization {
          id
        }
        meetingGroup {
          id
          isFormalOneonone
        }
        participants {
          edges {
            node {
              id
              status
              user {
                id
                name
                firstName
                lastName
                avatar
              }
            }
          }
        }
      }
    }
  }
`;
